import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";

import {
    DUBAI_ISO,
    MY_REWARDS_LINK,
    USER_COUNTRY,
} from "../../../public/Constants/EnumConstants";
import {
    AccountSettings,
    Credits,
    FAQs,
    Logout,
    MyDashboard,
    MyOrders,
    MyStylePreference,
    Referrals,
    Wishlist,
} from "../../../public/Theme";

export const SIDE_BAR_LINKS = [
    {
        id: "dashboard-link",
        icon: MyDashboard,
        text: "My Dashboard",
        link: FRONTEND_ENDPOINTS?.DASHBOARD,
    },
    {
        id: "track-order",
        icon: MyOrders,
        text: "Track My Order",
        link: FRONTEND_ENDPOINTS?.MY_BOXES_LINK,
    },
    {
        id: "account-settings-link",
        icon: AccountSettings,
        text: "Account Settings",
        link: FRONTEND_ENDPOINTS?.ACCOUNT_SETTINGS,
        bigIcon: AccountSettings,
    },
    {
        id: "my-style-Preferences-link",
        icon: MyStylePreference,
        text: "My Style Preferences",
        link: FRONTEND_ENDPOINTS?.MY_STYLE_PROFIL,
        bigIcon: MyStylePreference,
    },
    {
        id: "my-referrals",
        icon: Referrals,
        text: "My Referrals",
        link: MY_REWARDS_LINK,
        bigIcon: Referrals,
    },
    {
        id: "my-wishlist",
        icon: Wishlist,
        text: "Wishlist",
        link: FRONTEND_ENDPOINTS.WISH_LIST,
        bigIcon: Wishlist,
    },

    {
        id: "faqs-link",
        icon: FAQs,
        text: "FAQs",
        link: FRONTEND_ENDPOINTS?.DASHBOARD_FAQ,
        bigIcon: FAQs,
    },
    {
        id: "logout-button",
        icon: Logout,
        text: "Logout",
        link: "#",
    },
];

export const UNPAID_SIDE_BAR_LINKS = [
    {
        id: "dashboard-link",
        icon: MyDashboard,
        text: "My Dashboard",
        link: FRONTEND_ENDPOINTS?.DASHBOARD,
    },
    {
        id: "account-settings-link",
        icon: AccountSettings,
        text: "Account Settings",
        link: FRONTEND_ENDPOINTS?.ACCOUNT_SETTINGS,
        bigIcon: AccountSettings,
    },
    {
        id: "my-wishlist",
        icon: Wishlist,
        text: "Wishlist",
        link: FRONTEND_ENDPOINTS.WISH_LIST,
        bigIcon: Wishlist,
    },
    {
        id: "faqs-link",
        icon: FAQs,
        text: "FAQs",
        link: FRONTEND_ENDPOINTS?.DASHBOARD_FAQ,
        bigIcon: FAQs,
    },
    {
        id: "logout-button",
        icon: Logout,
        text: "Logout",
        link: "#",
    },
];

export const SIDE_BAR_LINKS_KSA = [
    {
        id: "dashboard-link",
        icon: MyDashboard,
        text: "My Dashboard",
        link: FRONTEND_ENDPOINTS?.DASHBOARD,
    },
    {
        id: "track-order",
        icon: MyOrders,
        text: "Track My Order",
        link: FRONTEND_ENDPOINTS?.MY_STYLE_JOURNEY,
    },
    {
        id: "account-settings-link",
        icon: AccountSettings,
        text: "Account Settings",
        link: FRONTEND_ENDPOINTS?.ACCOUNT_SETTINGS,
        bigIcon: AccountSettings,
    },
    {
        id: "my-style-Preferences-link",
        icon: MyStylePreference,
        text: "My Style Preferences",
        link: FRONTEND_ENDPOINTS?.MY_STYLE_PROFIL,
        bigIcon: MyStylePreference,
    },
    {
        id: "my-referrals",
        icon: Referrals,
        text: "My Referrals",
        link: MY_REWARDS_LINK,
        bigIcon: Referrals,
    },
    {
        id: "my-wishlist",
        icon: Wishlist,
        text: "Wishlist",
        link: FRONTEND_ENDPOINTS.WISH_LIST,
        bigIcon: Wishlist,
    },
    {
        id: "faqs-link",
        icon: FAQs,
        text: "FAQs",
        link: FRONTEND_ENDPOINTS?.DASHBOARD_FAQ,
        bigIcon: FAQs,
    },
    {
        id: "logout-button",
        icon: Logout,
        text: "Logout",
        link: "#",
    },
];

export const SIDE_BAR_LINKS_KSA_UNPAID = [
    {
        id: "dashboard-link",
        icon: MyDashboard,
        text: "My Dashboard",
        link: FRONTEND_ENDPOINTS?.DASHBOARD,
    },
    {
        id: "account-settings-link",
        icon: AccountSettings,
        text: "Account Settings",
        link: FRONTEND_ENDPOINTS?.ACCOUNT_SETTINGS,
        bigIcon: AccountSettings,
    },
    {
        id: "my-wishlist",
        icon: Wishlist,
        text: "Wishlist",
        link: FRONTEND_ENDPOINTS.WISH_LIST,
        bigIcon: Wishlist,
    },
    {
        id: "faqs-link",
        icon: FAQs,
        text: "FAQs",
        link: FRONTEND_ENDPOINTS?.DASHBOARD_FAQ,
        bigIcon: FAQs,
    },
    {
        id: "logout-button",
        icon: Logout,
        text: "Logout",
        link: "#",
    },
];

const SIDE_BAR_LINKS_UNPAID_USER = [
    {
        id: "dashboard-link",
        icon: MyDashboard,
        text: "My Dashboard",
        link: FRONTEND_ENDPOINTS?.SURVEY,
    },
    {
        id: "faqs-link",
        icon: FAQs,
        text: "FAQs",
        link: FRONTEND_ENDPOINTS?.FAQ,
        bigIcon: FAQs,
    },
    {
        id: "logout-button",
        icon: Logout,
        text: "Logout",
        link: "#",
    },
];

const SIDE_BAR_LINKS_LOGOUT_USER = [
    {
        id: "faqs-link",
        icon: FAQs,
        text: "FAQs",
        link: FRONTEND_ENDPOINTS?.FAQ,
        bigIcon: FAQs,
    },
];

export const getSidebarMenuList = (userData) => {
    if (userData) {
        // if (
        //     userData?.payment_status === "paid" &&
        //     userData?.submitted_survey === true
        // ) {
        if (userData?.detected_signup_country === DUBAI_ISO)
            return userData?.payment_status != "paid"
                ? UNPAID_SIDE_BAR_LINKS
                : SIDE_BAR_LINKS;
        else
            return userData?.payment_status != "paid"
                ? SIDE_BAR_LINKS_KSA_UNPAID
                : SIDE_BAR_LINKS_KSA;
        // }
        // return SIDE_BAR_LINKS_UNPAID_USER;
    }
    return SIDE_BAR_LINKS_LOGOUT_USER;
};

export const DASHBBOARD_ITEMS = [
    { text: "My Orders", link: "/dashboard/my-orders" },
    { text: "Order A Box", link: "/dashboard/orderABox" },
    { text: "My Style Preferences", link: "/dashboard/myStyleProfile" },
    { text: "Account Settings", link: "/dashboard/accountSettings" },
    { text: "My Referrals", link: "/dashboard/myRewards" },
    // { text: "My Credits", link: "/dashboard/my-credits" },
    { text: "My Wishlist", link: FRONTEND_ENDPOINTS.WISH_LIST },
    { text: "FAQs", link: "/dashboard/faqs" },
];

export const UNPAID_ITEMS = [
    { text: "Account Settings", link: "/dashboard/accountSettings" },
    { text: "My Referrals", link: "/dashboard/myRewards" },
    { text: "My Wishlist", link: FRONTEND_ENDPOINTS.WISH_LIST },
    { text: "FAQs", link: "/dashboard/faqs" },
];

export const resolveText = (text, pathName) => {
    if (text === "My Dashboard") {
        return pathName.includes("shop") ? "My Account" : text;
    }
    return text;
};
